<template>
	<div class="header-placeholder">
		<div class="topHeader">
			<div class="header_main">
				<div class="header_left">
					<router-link to="/">
						<span class="logo-css">
							<img src="@/assets/logo1.png" alt="" />
							<span class="">云桌面&机位图</span>
						</span>
					</router-link>
					<el-menu
						:default-active="activeMenu"
						mode="horizontal"
						class="menu-main"
						text-color="#ffffff"
						active-text-color="#ffffff"
						router>
						<el-menu-item
							v-for="route in routes"
							:key="route.path"
							:index="route.path"
							>{{ route.meta.title }}</el-menu-item
						>
						<el-menu-item class="seat-link">
							<a
								href="https://www.xiaobaibar.net/wbnt/index/Seat/seat"
								target="_blank">
								<img
									src="@/assets/img/hot.gif"
									alt=""
									srcset="" />
								<span>机位图</span>
							</a>
						</el-menu-item>
					</el-menu>
				</div>
				<div>
					<a
						class="go_yun_btn"
						href="http://design.yundesktop.com"
						target="_blank"
						>云桌面入口</a
					>
					<a
						class="go_yun_btn"
						href="http://agent.yundesktop.com"
						target="_blank"
						>代理商入口</a
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Headers',
	data() {
		return {
			yun_url: 'http://design.yundesktop.com',
		}
	},
	computed: {
		routes() {
			return this.$router.options.routes.filter((v) => !v.meta.hidden)
		},
		activeMenu() {
			const route = this.$route
			const { meta, path } = route
			if (meta.activeMenu) {
				return meta.activeMenu
			}

			return path
		},
	},
	created() {
		if (process.env.NODE_ENV == '') {
		} else {
		}
	},
	methods: {
		logoImg() {
			window.location.reload()
		},
	},
}
</script>

<style scoped lang="less">
.header-placeholder {
	width: 100%;
	height: 60px;
}
.topHeader {
	min-width: 1200px;
	width: 100%;
	height: 60px;
	box-sizing: border-box;
	background: #1786dc;
	position: fixed;
	top: 0%;
	z-index: 9999;
}
.header_main {
	width: 1200px;
	height: 60px;
	margin: auto;
	display: flex;
	align-items: center;
	justify-content: space-between;
	.header_left {
		display: flex;
		align-items: center;
		img {
			width: 26px;
			height: 26px;
			object-fit: cover;
			object-position: left;
			margin-right: 4px;
		}
	}
	.seat-link {
		display: flex;
		align-items: center;
		justify-content: center;
		img {
			width: 28px;
			height: 28px;
		}
	}
	.logo-css {
		display: flex;
		align-items: center;
		color: #fff;
		font-size: 22px;
		font-family: '微软雅黑';
		font-weight: bold;
	}
}
.go_yun_btn {
  display: inline-block;
	color: #ffffff;
	width: 100px;
	height: 40px;
	line-height: 40px;
	font-size: 12px;
	text-align: center;
	text-decoration: none;
	background-color: inherit;
	border: 1px solid #ffffff;
	border-radius: 20px;
  margin-left: 12px;
	cursor: pointer;
	&:hover {
		background: #fff;
		color: #428bca;
	}
}

.menu-main.el-menu--horizontal {
	border-bottom: none;
	padding-left: 40px;
	background-color: #1786dc;

	& > .el-menu-item {
		font-size: 16px;
		height: 40px;
		line-height: 40px;
		background-color: #1786dc !important;
	}
	& > .el-menu-item:hover {
		background-color: #1786dc !important;
		color: #e6e6e6 !important;
	}
}

.active {
	border-bottom: 3px solid #ffffff;
}
</style>
